// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3vBIM","savePackageButton":"ClientWallet_savePackageButton__3jFLt"};